/**
 * Created by mac on 10/5/25
 */

class Haptics {
    constructor() {
        this.minInterval = 120;
        this.lastTime = 0;
    }

    static isAvailable() {
        return connector.platform.hasVibration();
    }

    apply(options) {
        if (cleverapps.settings.vibrate === false || !cleverapps.config.vibration) {
            return false;
        }

        const t = performance.now();
        if (t - this.lastTime < this.minInterval) {
            return false;
        }

        this.lastTime = t;

        if (cleverapps.config.debugMode && !Haptics.isAvailable()) {
            const url = bundles.main.urls.haptic_tick.resolve();
            if (url) {
                cleverapps.audio.engine.playSound(url.getUrl());
            }
        }

        try {
            connector.platform.vibrate(options);
        } catch (_) { /* empty */ }
        return true;
    }
}
